import React from 'react';
import {
  Datagrid,
  EditButton,
  List,
  TextField,
  TextInput,
  BooleanField,
  CreateButton,
  TopToolbar,
} from 'react-admin';

const UserFilters = [
  <TextInput key="search" label="Search by Username" source="q" alwaysOn />
];

const ListActions = () => (
  <TopToolbar>
    <CreateButton label="New User" />
  </TopToolbar>
);

const UserList = () => (
  <List filters={UserFilters} actions={<ListActions />}>
    <Datagrid
      rowClick={false}
      bulkActionButtons={false}
    >
      <TextField source="id" />
      <TextField source="username" />
      <TextField source="role" />
      <BooleanField source="active" />
      <EditButton />
    </Datagrid>
  </List>
);

export default UserList;
